'use strict';

const
    menuBox: HTMLElement = document.querySelector(".mobile-menu-box")!,
    menuButtons = document.querySelectorAll(".hamburger");

menuButtons.forEach(btn => {
    btn.addEventListener('click', function (_e) {
        menuBox.classList.toggle("active");
        document.body.classList.toggle('overflow-hidden');
        document.body.classList.toggle('mobile-menu-open');
        if (menuBox.classList.contains("active")) {
            disableScroll();
        } else {
            enableScroll();
        }
    });
})

if (window.innerWidth > document.body.clientWidth + 5) {
    document.body.classList.add('has-scrollbar');
    document.body.style.setProperty('--scroll-bar', (window.innerWidth - document.body.clientWidth) + 'px');
} else {
    document.body.classList.remove('has-scrollbar');
}

function preventDefault(e: Event) {
    e.preventDefault();
}

function preventDefaultForScrollKeys(e: KeyboardEvent) {
    switch(e.code) {
        case "Space":
        case "ArrowLeft":
        case "ArrowUp":
        case "ArrowRight":
        case "ArrowDown":
            preventDefault(e);
            return false;
    }
    return true
}

function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener('wheel', preventDefault, { passive: false }); // modern desktop
    window.addEventListener('touchmove', preventDefault, { passive: false }); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener('wheel', preventDefault, false);
    window.removeEventListener('touchmove', preventDefault, false);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

